import {defaults} from "../defaults";

$(function () {
    defaults.load();
});